// import querystring from 'querystring-browser';
import getVideoFeedUrl from 'helpers/feeds/videoHelpers';
import { getFeedUrl } from 'helpers/feeds/generalHelpers';
import reducerRegistry from 'reduxUtils/reducerRegistry';
// import { TOI_FEED_DOMAIN } from '../../constants';
import makeRequest from 'utils/makeRequest';
import { getMsidFromPath } from 'utils/common';
import _get from 'lodash.get';
import { receivePrimeshowData } from 'routes/toiplusprimeshow/redux';

const reducerName = 'articleshow';
const createActionName = name => `toi/${reducerName}/${name}`;

// actions
export const RECEIVE_DATA = createActionName('RECEIVE_DATA');
export const HANDLE_DATA_ERROR = createActionName('HANDLE_DATA_ERROR');
// export const TOGGLE_NIC = createActionName('TOGGLE_NIC');
// export const RECEIVE_DATA_NIC = createActionName('RECEIVE_DATA_NIC');
// export const NIC_LOADING = createActionName('NIC_LOADING');
// export const NIC_LOADED = createActionName('NIC_LOADED');
export const DATA_LOADING = createActionName('DATA_LOADING');
export const DATA_LOADED = createActionName('DATA_LOADED');
export const ADD_DOCK_CANDIDATE = createActionName('ADD_DOCK_CANDIDATE');
export const ADD_UNDOCK_CANDIDATE = createActionName('ADD_UNDOCK_CANDIDATE');
export const DELETE_DOCK_CANDIDATE = createActionName('DELETE_DOCK_CANDIDATE');
export const DELETE_UNDOCK_CANDIDATE = createActionName(
  'DELETE_UNDOCK_CANDIDATE',
);
export const OPEN_VIDEO_THEATRE = createActionName('OPEN_VIDEO_THEATRE');
export const CLOSE_VIDEO_THEATRE = createActionName('CLOSE_VIDEO_THEATRE');
export const RECEIVE_DATA_VIDEO_THEATRE_SLIDER = createActionName(
  'RECEIVE_DATA_VIDEO_THEATRE_SLIDER',
);
export const ADD_NEXT_VIDEO_MSID = createActionName('ADD_NEXT_VIDEO_MSID');
export const ELECTIONS_DATA_LOADED = createActionName('ELECTIONS_DATA_LOADED');
export const EXITPOLL_DATA_LOADED = createActionName('EXITPOLL_DATA_LOADED');
export const ASBREIFS_DATA_LOADED = createActionName('ASBREIFS_DATA_LOADED');
export const GEOLOCATION_VALUE = createActionName('GEOLOCATION_VALUE');
export const AB_TEST_ON = createActionName('AB_TEST_ON');
export const ARTICLE_TO_SHOW_COUNT = createActionName('ARTICLE_TO_SHOW_COUNT');
export const ARTICLE_TO_SHOW_RESET_DAYS = createActionName(
  'ARTICLE_TO_SHOW_RESET_DAYS',
);
export const LOAD_MINITV_COMPONENT = createActionName('LOAD_MINITV_COMPONENT');

function getAdsData(data) {
  const newData = data;
  if (data && data.id) {
    const ads = _get(data, 'ads.dfp.slots', {});
    const ctnAds = _get(data, 'ads.ctn.slots', {});
    let counter = 0;
    let adsKeys = Object.keys(ads);
    // let divId;
    if (adsKeys && adsKeys.length > 0) {
      for (; counter < adsKeys.length; counter += 1) {
        if (
          ads[adsKeys[counter]].experiment &&
          ads[adsKeys[counter]].experiment.adCode
        ) {
          ads[adsKeys[counter]].experiment.divId = ads[adsKeys[counter]].divId;
          newData.ads.dfp.slots[adsKeys[counter]] = {
            ...ads[adsKeys[counter]],
            ...ads[adsKeys[counter]].experiment,
          };

          newData.ads.dfp.slots[adsKeys[counter]].experiment = null;
        }
      }
    }

    counter = 0;
    adsKeys = Object.keys(ctnAds);

    if (adsKeys && adsKeys.length > 0) {
      for (; counter < adsKeys.length; counter += 1) {
        if (
          ctnAds[adsKeys[counter]].experiment &&
          ctnAds[adsKeys[counter]].experiment.slotId
        ) {
          newData.ads.ctn.slots[adsKeys[counter]].slotId =
            ctnAds[adsKeys[counter]].experiment.slotId;
        }
      }
    }
  }

  return newData;
}
// action creators
function receiveArticleshowData(data, abTestOn) {
  // Update ads if AB test is on - Code Starts
  if (abTestOn) {
    // eslint-disable-next-line no-param-reassign
    data = getAdsData(data);
  }

  // Update ads if AB test is on - Code Ends
  return {
    type: RECEIVE_DATA,
    payload: {
      data,
      msid: data.id,
    },
  };
}

function handleArticleshowDataError(error) {
  return {
    type: HANDLE_DATA_ERROR,
    error,
  };
}

export function updateAdsForABExperiment(data) {
  // eslint-disable-next-line no-param-reassign
  data = getAdsData(data);
  // Update ads if AB test is on - Code Ends
  return {
    type: RECEIVE_DATA,
    payload: {
      data,
      msid: data.id,
    },
  };
  // receiveArticleshowData(data, true);
}

export function updateArticleToShowCount(data) {
  return {
    type: ARTICLE_TO_SHOW_COUNT,
    payload: data,
  };
}

export function updateArticleToShowResetDays(data) {
  return {
    type: ARTICLE_TO_SHOW_RESET_DAYS,
    payload: data,
  };
}

// export function toggleNIC(isOpen) {
//   return {
//     type: TOGGLE_NIC,
//     payload: {
//       isNicOpen: isOpen,
//     },
//   };
// }

// function nicLoading() {
//   return {
//     type: NIC_LOADING,
//     payload: {},
//   };
// }
// function nicLoaded() {
//   return {
//     type: NIC_LOADED,
//     payload: {},
//   };
// }
// function receiveNicData(url, data) {
//   return {
//     type: RECEIVE_DATA_NIC,
//     payload: {
//       nic: {
//         url,
//         data: data.data,
//       },
//     },
//   };
// }

function dataLoading() {
  return {
    type: DATA_LOADING,
    payload: {},
  };
}

function dataLoaded() {
  return {
    type: DATA_LOADED,
    payload: {},
  };
}

function receiveElectionsData(data) {
  return {
    type: ELECTIONS_DATA_LOADED,
    payload: data.data,
  };
}

function receiveExitPollData(data) {
  return {
    type: EXITPOLL_DATA_LOADED,
    payload: data.data,
  };
}
function receiveAsBreifsData(data) {
  return {
    type: ASBREIFS_DATA_LOADED,
    payload: data.data,
  };
}

export function articleABTestOn() {
  return {
    type: AB_TEST_ON,
    payload: {
      data: true,
    },
  };
}

export function addDockCandidate(data) {
  return {
    type: ADD_DOCK_CANDIDATE,
    payload: {
      data,
    },
  };
}
export function addUnDockCandidate(data) {
  return {
    type: ADD_UNDOCK_CANDIDATE,
    payload: {
      data,
    },
  };
}
export function deleteDockCandidate() {
  return {
    type: DELETE_DOCK_CANDIDATE,
    payload: {},
  };
}
export function deleteUnDockCandidate() {
  return {
    type: DELETE_UNDOCK_CANDIDATE,
    payload: {},
  };
}

export function openVideoTheatre(sliderPath, currId, currItem) {
  return {
    type: OPEN_VIDEO_THEATRE,
    payload: {
      videoTheatreSliderPath: sliderPath,
      videoTheatreCurrMsid: currId,
      videoTheatreCurrItem: currItem,
    },
  };
}
export function closeVideoTheatre() {
  return {
    type: CLOSE_VIDEO_THEATRE,
    payload: {},
  };
}

function recieveVideoTheatreSliderData(data) {
  return {
    type: RECEIVE_DATA_VIDEO_THEATRE_SLIDER,
    payload: {
      data: data.data,
    },
  };
}

export function addNextVideoMsid(msidForNextVideo, slikeId) {
  return {
    type: ADD_NEXT_VIDEO_MSID,
    payload: { msidForNextVideo, slikeId },
  };
}

export function loadMiniTvComponent(loadedMiniTvComponent) {
  return {
    type: LOAD_MINITV_COMPONENT,
    payload: loadedMiniTvComponent,
  };
}

// export function saveGeoLocationValue(value) {
//   return {
//     type: GEOLOCATION_VALUE,
//     payload: {
//       geolocationValue: value,
//     },
//   };
// }

/*
function getProtocol() {
  let protocol = 'http';
  if (typeof window !== 'undefined') {
    protocol = 'https';
  }
  return protocol;
}
*/

//data gatherers
function fetchArticleshowData(params, isAppView) {
  const appParameter = isAppView ? '&frmapp=yes' : '';
  const primeuser = params.frmprime === 'yes' ? '&isprime=true' : '';
  const isWapView = !!params.isWapView;
  const articlePath = `/articleshow/${getMsidFromPath(params.fullPath)}.cms`;
  const url = `${getFeedUrl()}/toi/web/show/news?path=${articlePath}${appParameter}${primeuser}`;
  return makeRequest.get(url, { isMobile: isWapView });
}

// function fetchNICData(nicUrl) {
//   const articlePath = `/articleshow/${getMsidFromPath(nicUrl)}.cms`;
//   const url = `${getFeedUrl()}/toi/web/show/news?path=${articlePath}`;
//   return makeRequest.get(url);
// }

function fetchVideoTheatreSliderData(sliderUrl, isWapView) {
  let url = sliderUrl;
  if (sliderUrl && sliderUrl.startsWith('https://')) {
    // const regexForExtractingSectionUrl = /^(http\:|https\:)(\/\/timesofindia.indiatimes.com\/)(\D+)(\/\D+\/)(videoshow\/\d+.cms)$/;
    const tempUrl = sliderUrl
      .replace('https://timesofindia.indiatimes.com/', '')
      .replace('https://toidev.indiatimes.com/', '')
      .replace(/\/videoshow\/\d+.cms/, '')
      .split('/');
    tempUrl.pop();
    url = getVideoFeedUrl({
      path: `/${tempUrl.join('/')}`,
      perpage: 10,
    });
  }
  return makeRequest.get(url, { isMobile: isWapView });
}

function fetchElectionsData(url, isWapView) {
  return makeRequest.get(url, { isMobile: isWapView });
}

function fetchExitPoll(url, isWapView) {
  return makeRequest.get(url, { isMobile: isWapView });
}

function fetchAsBreifs(url, isWapView) {
  return makeRequest.get(url, { isMobile: isWapView });
}

//exposed functions
export function loadArticleshowData(params, isAppView, abTestRunning) {
  return dispatch => {
    dispatch(dataLoading());
    return fetchArticleshowData(params, isAppView)
      .then(data => {
        dispatch(dataLoaded());
        dispatch(receiveArticleshowData(data.data, abTestRunning));
        dispatch(receivePrimeshowData(data.data));
      })
      .catch(error => {
        dispatch(dataLoaded());
        dispatch(handleArticleshowDataError(error));
      });
  };
}

// export function loadNIC(nicUrl) {
//   return dispatch => {
//     dispatch(nicLoading());
//     fetchNICData(nicUrl)
//       .then(data => dispatch(receiveNicData(nicUrl, data)))
//       .then(() => dispatch(nicLoaded()))
//       .catch(error => dispatch(handleArticleshowDataError(error)));
//   };
// }
export function loadVideoTheatreSlider(url, isWapView) {
  return dispatch =>
    fetchVideoTheatreSliderData(url, isWapView).then(data =>
      dispatch(recieveVideoTheatreSliderData(data)),
    );
  // .catch(error => false);
}

export function loadElections(url, isWapView) {
  return dispatch =>
    fetchElectionsData(url, isWapView).then(data =>
      dispatch(receiveElectionsData(data)),
    );
  // .catch(error => false);
}

export function loadExitPoll(url, isWapView) {
  return dispatch =>
    fetchExitPoll(url, isWapView).then(data =>
      dispatch(receiveExitPollData(data)),
    );
  // .catch(error => false);
}
export function loadAsBreifs(url, isWapView) {
  return dispatch =>
    fetchAsBreifs(url, isWapView).then(data =>
      dispatch(receiveAsBreifsData(data)),
    );
  // .catch(error => false);
}

// reducer
export default function reducer(state = {}, action = {}) {
  switch (action.type) {
    case RECEIVE_DATA: {
      const articleShowData = state.data ? { ...state.data } : {};
      articleShowData[action.payload.msid] = action.payload.data;
      return {
        ...state,
        // seoData: action.payload.seoData,
        // maxAge: action.payload.maxAge,
        // adsData: action.payload.adsData,
        // mobileAdsData: action.payload.mobileAdsData,
        // headScripts: action.payload.headScripts,
        // headStyles: action.payload.headStyles,
        // story: action.payload.story,
        data: articleShowData,
      };
    }
    case DATA_LOADING: {
      return {
        ...state,
        dataLoading: true,
      };
    }
    case DATA_LOADED: {
      return {
        ...state,
        dataLoading: false,
      };
    }
    // case NIC_LOADING: {
    //   return {
    //     ...state,
    //     nicLoading: true,
    //   };
    // }
    // case NIC_LOADED: {
    //   return {
    //     ...state,
    //     nicLoading: false,
    //   };
    // }
    // case TOGGLE_NIC: {
    //   return {
    //     ...state,
    //     isNicOpen: action.payload.isNicOpen,
    //   };
    // }
    // case RECEIVE_DATA_NIC: {
    //   return {
    //     ...state,
    //     nic: action.payload.nic,
    //   };
    // }
    case ADD_DOCK_CANDIDATE: {
      return {
        ...state,
        dockCandidate: action.payload.data,
      };
    }
    case ADD_UNDOCK_CANDIDATE: {
      return {
        ...state,
        unDockCandidate: action.payload.data,
      };
    }
    case DELETE_DOCK_CANDIDATE: {
      return {
        ...state,
        dockCandidate: undefined,
      };
    }
    case DELETE_UNDOCK_CANDIDATE: {
      return {
        ...state,
        unDockCandidate: undefined,
      };
    }
    case OPEN_VIDEO_THEATRE: {
      return {
        ...state,
        isVideoTheatreOpen: true,
        videoTheatreSliderPath: action.payload.videoTheatreSliderPath,
        videoTheatreCurrMsid: action.payload.videoTheatreCurrMsid,
        videoTheatreCurrItem: action.payload.videoTheatreCurrItem,
      };
    }
    case CLOSE_VIDEO_THEATRE: {
      return {
        ...state,
        isVideoTheatreOpen: false,
        videoTheatreSliderPath: undefined,
      };
    }
    case RECEIVE_DATA_VIDEO_THEATRE_SLIDER: {
      return {
        ...state,
        videoTheatreSliderData: action.payload.data.data.items,
      };
    }
    case ADD_NEXT_VIDEO_MSID: {
      return {
        ...state,
        msidForNextVideo: action.payload.msidForNextVideo,
        slikeId: action.payload.slikeId,
      };
    }
    case LOAD_MINITV_COMPONENT: {
      return {
        ...state,
        loadedMiniTvComponent: action.payload,
      };
    }
    case ELECTIONS_DATA_LOADED: {
      return {
        ...state,
        electionsData: action.payload || {},
      };
    }
    case EXITPOLL_DATA_LOADED: {
      return {
        ...state,
        exitPollData: action.payload || {},
      };
    }
    case ASBREIFS_DATA_LOADED: {
      return {
        ...state,
        asBriefsData: action.payload,
      };
    }
    case GEOLOCATION_VALUE: {
      return {
        ...state,
        geolocationValue: action.payload.geolocationValue || 1,
      };
    }
    case AB_TEST_ON: {
      return {
        ...state,
        abTestRunning: true,
      };
    }
    case ARTICLE_TO_SHOW_COUNT: {
      return {
        ...state,
        articleToShowCount: action.payload,
      };
    }
    case ARTICLE_TO_SHOW_RESET_DAYS: {
      return {
        ...state,
        articleToShowResetDays: action.payload,
      };
    }
    default:
      return state;
  }
}

reducerRegistry.register(reducerName, reducer);
